import { render, staticRenderFns } from "./MfOrderbookSrc.vue?vue&type=template&id=90d3b6ee&"
import script from "./MfOrderbookSrc.vue?vue&type=script&lang=js&"
export * from "./MfOrderbookSrc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports